import React, { useState } from 'react';
import './PasswordReset.css';

interface PasswordResetRequestProps {
  onBack: () => void;
}

const PasswordResetRequest: React.FC<PasswordResetRequestProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const basePath = '/databaseOps/';
      const response = await fetch(`${basePath}requestPasswordReset.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Anfrage fehlgeschlagen');
        setIsLoading(false);
        return;
      }

      // Show success message
      setSuccess(true);
      setIsLoading(false);

    } catch (error: any) {
      console.error('Password reset request error:', error);
      setError('Netzwerkfehler. Bitte versuchen Sie es erneut.');
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="password-reset-container">
        <div className="password-reset-box">
          <div className="password-reset-success">
            <h3>E-Mail gesendet</h3>
            <p>
              Wenn ein Konto mit dieser E-Mail-Adresse existiert, wurde eine E-Mail mit
              Anweisungen zum Zurücksetzen des Passworts gesendet.
            </p>
            <p>Bitte überprüfen Sie Ihren Posteingang und folgen Sie dem Link in der E-Mail.</p>
            <p className="password-reset-note">
              Der Link ist 15 Minuten gültig.
            </p>
            <button onClick={onBack} className="btn-back">
              Zurück zur Anmeldung
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="password-reset-container">
      <div className="password-reset-box">
        <div className="password-reset-header">
          <h2>Passwort zurücksetzen</h2>
          <p>Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen zu erhalten.</p>
        </div>

        {error && (
          <div className="password-reset-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-Mail-Adresse</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              placeholder="ihre.email@example.com"
              autoFocus
            />
          </div>

          <div className="password-reset-actions">
            <button
              type="button"
              onClick={onBack}
              disabled={isLoading}
              className="btn-secondary"
            >
              Abbrechen
            </button>
            <button type="submit" disabled={isLoading} className="btn-primary">
              {isLoading ? 'Senden...' : 'Link senden'}
            </button>
          </div>
        </form>

        <div className="password-reset-info">
          <p>
            Sie erhalten eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts.
            Der Link ist 15 Minuten gültig.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetRequest;
